import { render, staticRenderFns } from "./FjsportsSample2View.vue?vue&type=template&id=078edf52&scoped=true&"
import script from "./FjsportsSample2View.vue?vue&type=script&lang=js&"
export * from "./FjsportsSample2View.vue?vue&type=script&lang=js&"
import style0 from "./FjsportsSample2View.vue?vue&type=style&index=0&id=078edf52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078edf52",
  null
  
)

export default component.exports